
import { Component, Vue } from 'vue-property-decorator'
import TicketFwbz from '@/views/Ticket/indexFwbz.vue'

@Component({
  name: 'AllMyOrderLists',
  components: {
    TicketFwbz
  }
})
export default class extends Vue {}
